/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import OrgAppsUsers from '../views/organization/application/users/OrgAppsUsers';
import OrgAppUserCreationBtn from '../views/organization/application/users/OrgAppUserCreationBtn';
import { getAllApplicationUsers } from '../../../../../store/reducers/applicationUsers/applicationUsersAction';
import { useCallback } from 'react';
const ManageOrgApplicationsUsersGeneralPage = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()


    const fetchApplicationsUsers = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllApplicationUsers()).unwrap()
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch])

    useEffect(() => {
        fetchApplicationsUsers()
    }, [fetchApplicationsUsers]);
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Applications Users General'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAppUserCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAppsUsers /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}


export default ManageOrgApplicationsUsersGeneralPage; 